import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function newRunReducer(state = initialState.newRun, action) {
  switch (action.type) {
    case types.NEW_RUN_LOCATION_ADD:
      if(state.locations.findIndex(x => x.id==action.location.id) >= 0){
        return state;
      }
      return {...state, locations: [...state.locations, action.location]};
    case types.NEW_RUN_LOCATION_REMOVE:
      return {...state, locations: [...state.locations.filter(x => x.id != action.location.id)]};
    case types.NEW_RUN_LOCATION_SETURGENT: {
      let locations = [...state.locations.map(y => {
        let returnLocation = {...y};
        if (returnLocation.id == action.location.id) {
          returnLocation.isUrgentJob = action.location.isUrgentJob;
        }
        return returnLocation;
      })];

      return {...state, locations};
    }
    case types.NEW_RUN_EDIT:
      // IF it's changing the type of run then the locations need to be cleared isCollectionRun
      if(state.run.isCollectionRun !== action.run.isCollectionRun) {        
        return {...initialState.newRun, run: { ...initialState.newRun.run, isCollectionRun: action.run.isCollectionRun }};
      }
      return {...state, run: { ...action.run }};
    case types.NEW_RUN_CREATED:
      return {...initialState.newRun};
    case types.NEW_RUN_SAVING:
      return {...state, saving: true};
    default:
      return state;
  }
}
